import React, { useEffect, useState } from "react";
import { NavBar, SideBar, Breadcrumb, UpdateBackground } from "../components";
import { handleOnClickLogout, getBackground, getAllCards } from "../constants";
import { useNavigate, useParams } from "react-router-dom";

const UpdatedBackground = () => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [initial, setInitial] = useState(false);
  const [backgroundData, setBackgroundData] = useState({});
  const [cards, setCards] = useState([]);
  const { backgroundId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [breads, setBreads] = useState(["Virtual Backgrounds"]);
  const changeBreadCrumbs = (i) => {
    setBreads(breads.slice(0, i + 1));
  };

  useEffect(() => {
    if (breads.length < 2 && initial) {
      navigate("/backgrounds");
    }
  }, [breads]);

  useEffect(() => {
    if (Object.keys(backgroundData).length > 0) {
      if (breads.length == 1) {
        setBreads([...breads, backgroundData.name]);
      }
    }
    setInitial(true);
  }, [backgroundData]);

  useEffect(() => {
    getBackground(token, backgroundId, setBackgroundData);
    getAllCards(token, setCards);
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-start items-center text-secondary">
      <NavBar
        handleLogout={handleOnClickLogout}
        setLoading={setLoading}
        token={token}
        interceptFunc={true}
      />
      <div className="flex flex-row w-full h-full">
        <SideBar active={breads[0].toLocaleLowerCase()} interceptFunc={true} />
        <div className="flex flex-col w-full">
          <Breadcrumb breads={breads} changeBreadCrumbs={changeBreadCrumbs} />
          <div className="flex flex-col w-full h-full justify-center items-center">
            {Object.keys(backgroundData).length === 0 ? (
              "Loading..."
            ) : (
              <UpdateBackground data_={backgroundData} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatedBackground;
